import config from '../../config'
import fetcher from '../fetcher'

export const getCheckoutUrl = async ({ productSlug, email } : { productSlug: string, email?: string }): Promise<string> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/payments/checkout/${productSlug}${email ? `?email=${encodeURIComponent(email)}` : ''}`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching checkout url: ${error instanceof Error ? error.message : error}`)
    throw error
  }
}

export const getCheckoutSuccess = async (sessionId: string): Promise<string> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/payments/success/${sessionId}`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching checkout success: ${error instanceof Error ? error.message : error}`)
    throw error
  }
}

export const getBillingPortalUrl = async (): Promise<string> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/payments/billing`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching billing portal url: ${error instanceof Error ? error.message : error}`)
    throw error
  }
}

